import { SpecIdWithMaterialIds } from '@shared/models/rx-rules-json-interface';
import { ProcedureSpecificationMaterialRule } from '@core/procedure-helpers/models/specification-material-rules-config';
import { ProcedureMapCheckedValue } from '@core/procedure-helpers/models/procedure-map-composites';
import { pmCompositeMatcher } from '@shared/utils/procedure-map-composites';
import { Maybe } from '@/types/globals';

export class ProcedureSpecificationMaterialParser<TUnitTypes extends number> {
	private readonly defaultProcedureRules: ProcedureSpecificationMaterialRule[];

	constructor(private procedureRules: ProcedureSpecificationMaterialRule[]) {
		this.defaultProcedureRules = procedureRules;
	}

	getDefaultRules(): ProcedureSpecificationMaterialRule[] {
		return this.defaultProcedureRules;
	}

	setRules(rules: ProcedureSpecificationMaterialRule[]): this {
		this.procedureRules = rules;

		return this;
	}

	getSpecIdsWithMaterialIds(pmToCheck: Maybe<ProcedureMapCheckedValue>, currentUnitTypeOnTooth: TUnitTypes): SpecIdWithMaterialIds[] {
		const procedureRule = this.getProcedureRule(pmToCheck);
		const unitTypeRule = procedureRule?.UnitTypeRules.find(({ Id }) => Id === currentUnitTypeOnTooth);

		if (!unitTypeRule?.Specifications?.length) {
			return [];
		}

		return unitTypeRule.Specifications.map(spec => ({
			Id: spec.Id,
			Materials: spec.Materials
		}));
	}

	private getProcedureRule(pmToCheck: Maybe<ProcedureMapCheckedValue>): Maybe<ProcedureSpecificationMaterialRule> {
		return (
			this.procedureRules?.find((procedureRule: ProcedureSpecificationMaterialRule) =>
				procedureRule.ProcedureMaps.some(p => pmCompositeMatcher(p, pmToCheck))
			) ?? null
		);
	}
}
